import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import * as en from "./en.json"
import * as sv from "./sv.json"

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        supportedLngs: ["en", "sv"],
        debug: false,
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"]
        },
        resources: {
            en: {
                translation: en
            },
            sv: {
                translation: sv
            }
        }
    })

export default i18n
